<template>
	<section
		class="block-vido margin-both-lg margin-auto container"
		:class="data.smaller_container ? 'container--medium' : ''"
	>
		<transition name="opacity">
			<div class="video-popup" v-show="popupOpen">
				<button @click="showHidePopup" class="close-btn">
					<span>Lukk video</span>
					<svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
						<defs />
						<path
							d="M25 0C11.188 0 0 11.188 0 25s11.188 25 25 25 25-11.187 25-25S38.813 0 25 0zm12.5 33.963L33.963 37.5 25 28.538 16.037 37.5 12.5 33.963 21.462 25 12.5 16.037l3.537-3.537L25 21.462l8.963-8.962 3.537 3.537L28.538 25l8.962 8.963z"
							fill="#fff"
							fill-rule="nonzero"
						/>
					</svg>
				</button>
				<div class="inner-pop">
					<div ref="videoPlayer" class="video-player" :class="uniqVideoClass" v-html="data.video"></div>
					<Preloader class="loader" />
				</div>
				<div class="overlay-popup" @click="showHidePopup"></div>
			</div>
		</transition>
		<div
			v-observe-visibility="visibilityChanged"
			class="inner"
			@click="showHidePopup"
			:class="{ 'video-is-playing': videoIsPlaying }"
		>
			<div class="inner-elements">
				<button class="playButton">
					<svg width="17" height="17" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg">
						<path
							fill="#fff"
							d="M6.8 12.325L11.9 8.5 6.8 4.675v7.65zM8.5 0C3.825 0 0 3.825 0 8.5S3.825 17 8.5 17 17 13.175 17 8.5 13.175 0 8.5 0zm0 15.3c-3.74 0-6.8-3.06-6.8-6.8 0-3.74 3.06-6.8 6.8-6.8 3.74 0 6.8 3.06 6.8 6.8 0 3.74-3.06 6.8-6.8 6.8z"
						/>
					</svg>
				</button>
				<h2 v-if="data.title" class="titler">{{ data.title }}</h2>
				<p v-if="data.description" class="description">{{ data.description }}</p>
			</div>
			<div class="overlay"></div>
			<WpImage
				v-if="data.video_placeholder"
				:image="data.video_placeholder"
				size="large"
				class="image_bg_video"
				background
				cover
			/>
		</div>
	</section>
</template>

<script>
import WpImage from '@/components/elements/WpImage'
import Preloader from '@/components/elements/Preloader'
import { play } from '@/components/../icons'
import shortid from 'shortid'

export default {
	name: 'vide-module',
	props: ['data'],
	data() {
		return {
			videoIsPlaying: false,
			apiInit: false,
			YTPlayer: null,
			popupOpen: false,
		}
	},
	watch: {
		popupOpen(val) {
			if (!this.YTPlayer) {
				this.initYoutubePlayers()
			}
			if (val) {
				this.playVideo()
				document.getElementsByTagName('html')[0].classList.add('popup-open')
			} else {
				this.pauseVideo()
				this.videoIsPlaying = false
				document.getElementsByTagName('html')[0].classList.remove('popup-open')
			}
		},
	},
	mounted() {
		const VM = this
		if (typeof YT == 'undefined' || typeof YT.Player == 'undefined') {
			var tag = document.createElement('script')
			tag.src = 'https://www.youtube.com/iframe_api'
			var firstScriptTag = document.getElementsByTagName('script')[0]
			firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

			/* window.onYouTubePlayerAPIReady = function() {
                console.log('darkGrayy')
                VM.initPlayer();
            }; */
		} else {
		}
		VM.initPlayer()
	},
	computed: {
		uniqVideoClass() {
			return 'video-' + shortid.generate()
		},
	},
	destroyed() {},
	components: {
		WpImage,
		Preloader,
	},
	methods: {
		initPlayer() {
			const element = this.$refs.videoPlayer
			if (element) {
				const src = window.jQuery(element).find('iframe')[0].src
				if (src.includes('https')) {
					window.jQuery(element).find('iframe')[0].src = src + '&enablejsapi=1'
				}
			}
		},
		displayPlayButton() {
			return play()
		},
		playPauseVideo() {
			if (this.videoIsPlaying) {
				this.videoIsPlaying = false
				this.stopVideo()
			} else {
				this.videoIsPlaying = true
				this.playVideo()
			}
		},
		stopVideo() {
			if (this.apiInit && this.YTPlayer) {
				this.YTPlayer.stopVideo()
			}
		},
		pauseVideo() {
			if (this.apiInit && this.YTPlayer) {
				this.YTPlayer.pauseVideo()
			}
		},
		playVideo() {
			if (this.apiInit && this.YTPlayer) {
				this.YTPlayer.playVideo()
			}
		},
		onPlayerStateChange(event) {
			if (event.data === 0) {
				//video ended, trigger stop action
				this.playPauseVideo()
			}
			if (event.data === 1) {
				//video is playing, (Maybe user click on iframe itself, so handle it)
				this.videoIsPlaying = true
			}
			if (event.data === 2) {
				//video paused
				this.videoIsPlaying = false
			}
		},
		onPlayerError() {
			this.videoIsPlaying = false
			//console.log("YouTube Error");
		},
		onPlayerReady() {
			this.apiInit = true
			this.playPauseVideo()
		},
		initYoutubePlayers() {
			const VM = this
			const element = this.$refs.videoPlayer
			if (!element) return false
			const ytiframe = window.jQuery(element).find('iframe')[0]
			this.YTPlayer = new YT.Player(ytiframe, {
				host: 'https://www.youtube.com',
				playerVars: {
					autoplay: 1,
					controls: 0,
					rel: 0,
					fs: 0,
				},
				events: {
					onStateChange: VM.onPlayerStateChange,
					onError: VM.onPlayerError,
					onReady: VM.onPlayerReady,
				},
			})
		},
		visibilityChanged(isVisible) {
			if (!isVisible && this.videoIsPlaying) {
				this.playPauseVideo()
			}
		},
		showHidePopup() {
			this.popupOpen = !this.popupOpen
			//this.playPauseVideo();
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
.video-popup {
	z-index: 999;
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	.overlay-popup {
		cursor: pointer;
		background-color: rgba(#141414, 0.99);
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		z-index: 10;
	}
	.inner-pop {
		text-align: left;
		position: relative;
		z-index: 20;
		max-width: 1200px;
		width: 90%;
		overflow: auto;
		display: flex;
		flex-direction: column;
		justify-content: center;
		@include mquery($tablet) {
			width: 95%;
		}
		@include mquery($phone) {
		}
		.loader {
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			position: absolute;
			z-index: 10;
			margin-top: 0 !important;
		}
	}
	.close-btn {
		cursor: pointer;
		background-color: transparent;
		position: absolute;
		top: 25px;
		right: 25px;
		z-index: 35;
		border: none;
		display: flex;
		align-items: center;
		color: var(--light);
		@include fluid-type($smallResText, $wideResText, 14px, 18px);

		svg {
			margin-left: 15px;
		}
		svg {
			path {
				@include transition(fill, 150ms);
			}
			@include mquery($tablet) {
				width: 40px;
				height: 40px;
			}
			@include mquery($phone) {
				width: 30px;
				height: 30px;
			}
		}
		&:hover {
			svg {
				path {
					fill: $darkGray;
				}
			}
		}
	}
	.video-player {
		z-index: 20;
		max-height: 0;
		position: relative;
		padding-bottom: 56.25%;
		iframe {
			width: 100%;
			height: 100%;
		}
	}
}
.module-video_block {
	position: relative;

	.image_bg_video {
		z-index: 5;
	}
	.inner {
		padding-bottom: 56.4%;
		height: 0;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		&:hover {
			.playButton {
				svg {
					transform: scale(1.1);
				}
				path {
					fill: var(--dark) Gray;
				}
			}
		}
		&.video-is-playing {
			.image_bg_video,
			.inner-elements,
			.overlay {
				opacity: 0;
				visibility: hidden;
			}
		}
	}
	.image_bg_video,
	.inner-elements,
	.overlay {
		transition: visibility 0.2s ease-in-out, opacity 0.2s ease-in-out;
		will-change: opacity, visibility;
	}
	.image_bg_video,
	.video-player iframe {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
	}

	.overlay {
		background-image: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, var(--dark) 100%);
		position: absolute;
		top: 50%;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 8;
	}
	.inner-elements {
		max-width: 600px;
		padding-left: 15px;
		padding-right: 15px;
		padding-bottom: 50px;
		margin-left: auto;
		margin-right: auto;
		color: var(--light);
		z-index: 10;
		position: relative;
		text-align: center;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		@include mquery($tablet) {
			padding-bottom: 40px;
		}
		@include mquery($phone) {
			padding-bottom: 15px;
		}
		.titler {
			margin-top: 50px;
			margin-bottom: 15px;
			@include fluid-type($smallResText, $wideResText, 20px, 30px);
			@include mquery($tablet) {
				margin-top: 10px;
				margin-bottom: 10px;
			}
		}
		.description {
			@include fluid-type($smallResText, $wideResText, 14px, 22px);
			margin-bottom: 0;
		}
	}
	.wp-image-vue .image {
		overflow: hidden;
	}
	.playButton {
		box-shadow: none;
		border: none;
		background-color: transparent;
		cursor: pointer;
		svg {
			width: 50px;
			height: 50px;
			@include transition(transform, 150ms);
			path {
				@include transition(fill, 250ms);
			}
			@include mquery($tablet) {
				width: 40px;
				height: 40px;
			}
			@include mquery($phone) {
				width: 35px;
				height: 35px;
			}
		}
	}
}
</style>
